import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import ReactDropDownCalender from '../components/ReactDropDownCalender';
import DropdownSelector from '../components/dropdowns/DropdownSelector';
import PrimeContractorToggle from '../components/toggle/PrimeContractorToggle';
import FieldContractorUserService from '../services/FieldContractorUsers';
import FieldTreeService from '../services/FieldTrees';
import {
  API_FLAG,
  DATE_TIME_FORMAT,
  DAYWORKER_NOT_EXIST_FLAG,
  MAX_DATE_RANGE_UNAPPROVED_WORKS,
  REQUEST_PARAMS,
  SCHEDULE_STATUS,
  UNAPPROVED_TYPE,
  WORK_HOUR_ZONES,
} from '../utilities/constants';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';

export class WorkUnapprovedSearchForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFormOpen: true,
    };
    this.clearFlag = false;
    this.isShowUnapproveTypeFilter =
      isPrimaryCompanyRoleId() ||
      props.scheduleFlag === SCHEDULE_STATUS.result.id;
  }

  componentDidUpdate() {
    if (this.clearFlag) {
      this.clearFlag = false;
    }
  }

  handleSearchFormToggle = () => {
    this.setState(prevState => ({
      isFormOpen: !prevState.isFormOpen,
    }));
  };

  handleChangeWorkHourZones = value => {
    const { tempSearchParams, onSetTempSearchParam } = this.props;
    let work_hour_zones = _.cloneDeep(tempSearchParams.work_hour_zones);
    const checkboxValue = _.toNumber(value);
    if (_.includes(work_hour_zones, checkboxValue)) {
      _.pull(work_hour_zones, checkboxValue);
    } else {
      work_hour_zones.push(checkboxValue);
    }
    onSetTempSearchParam('work_hour_zones', work_hour_zones);
  };

  handleChangeDate = (name, value) => {
    const { onSetTempSearchParam, tempSearchParams } = this.props;
    const targetDate = {
      date_from: tempSearchParams.date_from,
      date_to: tempSearchParams.date_to,
      [name]: value,
    };
    const dateRange = moment(targetDate.date_to).diff(
      moment(targetDate.date_from),
      'day'
    );
    if (dateRange < 0) {
      onSetTempSearchParam(name === 'date_from' ? 'date_to' : 'date_from', value);
    } else if (dateRange > MAX_DATE_RANGE_UNAPPROVED_WORKS) {
      if (name === 'date_from') {
        const dateTo = moment(targetDate.date_from)
          .add(MAX_DATE_RANGE_UNAPPROVED_WORKS, 'day')
          .format(DATE_TIME_FORMAT.slashDateFormat);
        onSetTempSearchParam('date_to', dateTo);
      } else {
        const dateFrom = moment(targetDate.date_to)
          .subtract(MAX_DATE_RANGE_UNAPPROVED_WORKS, 'day')
          .format(DATE_TIME_FORMAT.slashDateFormat);
        onSetTempSearchParam('date_from', dateFrom);
      }
    }
    onSetTempSearchParam(name, value);
  };

  handleChangeDayWorkerNotExistFlag = (name, value) => {
    const { onSetTempSearchParam } = this.props;
    const toggledValue = _.toNumber(value)
      ? DAYWORKER_NOT_EXIST_FLAG.uncheck
      : DAYWORKER_NOT_EXIST_FLAG.check;

    onSetTempSearchParam(name, toggledValue);
  };

  handleResetSearchParam = () => {
    const { onResetSearchParam, isLoading } = this.props;

    if (isLoading) {
      return;
    }
    this.clearFlag = true;
    onResetSearchParam();
  };

  handleSetSearchParam = () => {
    const { onSetSearchParam, isLoading } = this.props;
    if (isLoading) return;

    onSetSearchParam();
  };

  render() {
    const {
      totalWorkItems,
      fieldId,
      tempSearchParams,
      scheduleFlag,
      partnerApprovalName,
      onSetTempSearchParam,
    } = this.props;
    const { isFormOpen } = this.state;

    return (
      <div className='schedulelist__searchform'>
        <div className='search-form'>
          <div className='search-form__header'>
            <div className='search-form__title'>
              検索条件（検索結果
              <span className='bold'>{totalWorkItems}</span>件)
            </div>
            <button
              id='accordion-toggle'
              className={`accordion__btn${isFormOpen ? ' show' : ''}`}
              onClick={this.handleSearchFormToggle}
            />
            <button
              className='btn-text--sm'
              onClick={this.handleResetSearchParam}
            >
              検索条件クリア
            </button>
          </div>
          <div
            id='search-form-accordion'
            className={`accordion${isFormOpen ? ' show' : ''}`}
          >
            <div className='search-form__body'>
              <div className='form form--search-form'>
                <div className='form__group flex-wrap'>
                  <div className='form-element'>
                    <div className='form-element__label'>
                      <span className='label'>作業日</span>
                    </div>
                    <div className='form-element__list'>
                      <div className='date-selector-panel__row'>
                        <ReactDropDownCalender
                          onChange={date =>
                            this.handleChangeDate('date_from', date)
                          }
                          value={tempSearchParams.date_from}
                          format={DATE_TIME_FORMAT.weekdaySlashDateFormat}
                        />
                        <p className='date-selector-panel__date-separator'>-</p>
                        <ReactDropDownCalender
                          onChange={date =>
                            this.handleChangeDate('date_to', date)
                          }
                          value={tempSearchParams.date_to}
                          format={DATE_TIME_FORMAT.weekdaySlashDateFormat}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='form-element'>
                    <div className='form-element__label'>
                      <span className='label'>時間帯</span>
                    </div>
                    <div className='form-element__list'>
                      {_.map(WORK_HOUR_ZONES, (zone, key) => (
                        <div
                          className='element__item'
                          key={`work_hour_zone_${zone.id}`}
                        >
                          <label
                            htmlFor={`work-hour-zone-${key}`}
                            className='checkbox'
                          >
                            <input
                              id={`work-hour-zone-${key}`}
                              type='checkbox'
                              name='work-hour-zone'
                              value={zone.id}
                              checked={_.includes(
                                tempSearchParams.work_hour_zones,
                                zone.id
                              )}
                              onChange={e => {
                                this.handleChangeWorkHourZones(e.target.value);
                              }}
                            />
                            <i className='i-2x' />
                            <span>{zone.name}</span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {this.isShowUnapproveTypeFilter && (
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>
                          {isPrimaryCompanyRoleId() ? '未対応絞り込み' : '　'}
                        </span>
                      </div>
                      <div className='form-element__list'>
                        <PrimeContractorToggle>
                          {_.map(UNAPPROVED_TYPE, type => (
                            <div
                              className='element__item'
                              key={type.value}
                            >
                              <label htmlFor={type.key} className='radio'>
                                <input
                                  id={type.key}
                                  type='radio'
                                  name='unapproved_type'
                                  value={type.value}
                                  checked={_.isEqual(
                                    _.toNumber(tempSearchParams.unapproved_type),
                                    type.value
                                  )}
                                  onChange={e =>
                                    onSetTempSearchParam(
                                      e.target.name,
                                      e.target.value
                                    )
                                  }
                                />
                                <i className='i-2x' />
                                <span>{`${type.name}${
                                  type.key === UNAPPROVED_TYPE.UNCONFIRMED.key
                                    ? partnerApprovalName
                                    : ''
                                }`}</span>
                              </label>
                            </div>
                          ))}
                        </PrimeContractorToggle>
                        {scheduleFlag === SCHEDULE_STATUS.result.id && (
                          <div className='element__item'>
                            <label
                              htmlFor='dayworker_not_exist_flag'
                              className='checkbox'
                            >
                              <input
                                id='dayworker_not_exist_flag'
                                type='checkbox'
                                name='dayworker_not_exist_flag'
                                value={
                                  tempSearchParams.dayworker_not_exist_flag ||
                                  DAYWORKER_NOT_EXIST_FLAG.uncheck
                                }
                                checked={_.isEqual(
                                  tempSearchParams.dayworker_not_exist_flag,
                                  DAYWORKER_NOT_EXIST_FLAG.check
                                )}
                                onClick={e =>
                                  this.handleChangeDayWorkerNotExistFlag(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-square i-2x' />
                              <span>人工未入力</span>
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div className='form-element'>
                    <div className='form-element__label'>
                      <span className='label'>元請担当者</span>
                    </div>
                    <div className='form-element__list'>
                      <DropdownSelector
                        className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                        label='選択してください'
                        multiple={true}
                        selectorName='manager_user_ids'
                        api={params =>
                          FieldContractorUserService.list(fieldId, params)
                        }
                        apiParams={{
                          field_id: fieldId,
                          limit: REQUEST_PARAMS.parentLimit,
                        }}
                        apiSearchKey='name'
                        selectedValues={tempSearchParams.manager_user_ids}
                        keyName='user_name'
                        valueName='user_id'
                        apiBindDataKey={'field_contractor_users'}
                        onSelect={onSetTempSearchParam}
                        clearFlag={this.clearFlag}
                      />
                    </div>
                  </div>

                  <PrimeContractorToggle>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>協力会社</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='field_tree_ids'
                          api={params =>
                            FieldTreeService.selectableCompaniesList(
                              fieldId,
                              params
                            )
                          }
                          offset={REQUEST_PARAMS.parentLimit}
                          apiParams={{
                            field_id: fieldId,
                            limit: REQUEST_PARAMS.parentLimit,
                            show_finished: API_FLAG.On,
                            show_no_foreman: API_FLAG.On,
                          }}
                          limit={REQUEST_PARAMS.parentLimit}
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.field_tree_ids}
                          keyName='name'
                          valueName='field_tree_id'
                          apiBindDataKey={'companies'}
                          onSelect={onSetTempSearchParam}
                          widthClass='dropdown__item--wide'
                          clearFlag={this.clearFlag}
                          exceptionAllLoadedLimit={true}
                        />
                      </div>
                    </div>
                  </PrimeContractorToggle>
                  <div className='form-element'>
                    <div className='form-element__list'>
                      <button
                        className='btn-fixedsize--stay search-form__btn--align-to-element'
                        onClick={this.handleSetSearchParam}
                      >
                        検索
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WorkUnapprovedSearchForm.jsx